import { render, staticRenderFns } from "./ability.vue?vue&type=template&id=1e899f30&scoped=true"
import script from "./ability.vue?vue&type=script&lang=js"
export * from "./ability.vue?vue&type=script&lang=js"
import style0 from "./ability.vue?vue&type=style&index=0&id=1e899f30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e899f30",
  null
  
)

export default component.exports